export const ExternalActions = Object.freeze({
  RELAY_EXTERNAL_API_CALL: 'RELAY_EXTERNAL_API_CALL',
} as const);

// These coachmark dismissal reasons are defined in the coachmark javascript and this
// constants object is just a mirror of those possible values
export const CoachmarkDismissReasons = Object.freeze({
  START_STATION: 'start_station',
  START_TRIAL: 'start_trial',
  UPGRADE: 'upgrade',
  NOT_NOW: 'not_now',
  ACCEPT_INVITATION_COMPLETE: 'accept_invitation_complete',
} as const);

export default ExternalActions;
